/**
 * Agreement Server
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { DetailedRecipientRequest } from '../model/detailedRecipientRequest';
// @ts-ignore
import { ErrorModel } from '../model/errorModel';
// @ts-ignore
import { MultiRequestResponseMessage } from '../model/multiRequestResponseMessage';
// @ts-ignore
import { MultirequestErrorList } from '../model/multirequestErrorList';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    MultiRecipientRequestServiceInterface
} from './multiRecipientRequest.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class MultiRecipientRequestService extends BaseService implements MultiRecipientRequestServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get the recipient requests with multi recipient request code
     * @param code Multi recipient request code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public multirecipientrequestsCodeGet(code: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<DetailedRecipientRequest>>;
    public multirecipientrequestsCodeGet(code: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<DetailedRecipientRequest>>>;
    public multirecipientrequestsCodeGet(code: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<DetailedRecipientRequest>>>;
    public multirecipientrequestsCodeGet(code: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling multirecipientrequestsCodeGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/multirecipientrequests/${this.configuration.encodeParam({name: "code", value: code, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<DetailedRecipientRequest>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the multi recipient request code of recipient for multiple jobs
     * @param accessToken Access Token
     * @param jobs Comma delimited job id list
     * @param recipientName Name of the recipient
     * @param recipientEmail Email of the recipient
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public multirecipientrequestsPost(accessToken: string, jobs: string, recipientName: string, recipientEmail: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MultiRequestResponseMessage>;
    public multirecipientrequestsPost(accessToken: string, jobs: string, recipientName: string, recipientEmail: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MultiRequestResponseMessage>>;
    public multirecipientrequestsPost(accessToken: string, jobs: string, recipientName: string, recipientEmail: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MultiRequestResponseMessage>>;
    public multirecipientrequestsPost(accessToken: string, jobs: string, recipientName: string, recipientEmail: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling multirecipientrequestsPost.');
        }
        if (jobs === null || jobs === undefined) {
            throw new Error('Required parameter jobs was null or undefined when calling multirecipientrequestsPost.');
        }
        if (recipientName === null || recipientName === undefined) {
            throw new Error('Required parameter recipientName was null or undefined when calling multirecipientrequestsPost.');
        }
        if (recipientEmail === null || recipientEmail === undefined) {
            throw new Error('Required parameter recipientEmail was null or undefined when calling multirecipientrequestsPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (jobs !== undefined && jobs !== null) {
            localVarFormParams = localVarFormParams.append('jobs', <any>jobs) as any || localVarFormParams;
        }
        if (recipientName !== undefined && recipientName !== null) {
            localVarFormParams = localVarFormParams.append('recipientName', <any>recipientName) as any || localVarFormParams;
        }
        if (recipientEmail !== undefined && recipientEmail !== null) {
            localVarFormParams = localVarFormParams.append('recipientEmail', <any>recipientEmail) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/multirecipientrequests`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MultiRequestResponseMessage>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
